module.exports = __webpack_public_path__ + "files/840c5fc064a019ad987a1000b6d392dd.png";